<template>
<!--  <v-btn-->
<!--      color="buttonAction"-->
<!--      @click="$router.push({name: 'CreateCertificate'})"-->
<!--      dark-->
<!--      fab-->

<!--      bottom-->
<!--      fixed-->
<!--      right-->
<!--      depressed-->
<!--  >-->
<!--    <v-icon >mdi-plus</v-icon>-->


<!--  </v-btn>-->
  <v-speed-dial
      v-model="fab"

      direction="top"
      transition="slide-y-reverse-transition"
  >
    <template v-slot:activator>
      <v-btn v-model="fab" color="orange darken-4" dark fab

             bottom
             fixed
             right
             depressed>
        <v-icon v-if="fab">fa-light fa-xmark</v-icon>
        <v-icon v-else>fa-light fa-plus</v-icon>
      </v-btn>
    </template>
    <v-btn fab dark color="primary" @click="changeRoute('RegisterDevice')">
      <v-icon>fa-light fa-pen-field</v-icon>
    </v-btn>
    <v-btn fab dark color="primary" @click="changeRoute('CreateCertificate')">
      <v-icon>fa-light fa-certificate</v-icon>
    </v-btn>
  </v-speed-dial>
</template>

<script>
export default {
  name: "speed-dial",
  data() {
    return {
      fab: false
    }
  },
  methods: {
    changeRoute(routeName) {
      this.$router.push({name: routeName}).catch(() => {
      })
    }
  }
}
</script>

<style scoped lang="scss">
.v-speed-dial {
  position: absolute;
}
.v-btn--floating {
  position: relative;
}
</style>